import { render, staticRenderFns } from "./principleBranchForm.vue?vue&type=template&id=1575e1f7&scoped=true&"
import script from "./principleBranchForm.vue?vue&type=script&lang=js&"
export * from "./principleBranchForm.vue?vue&type=script&lang=js&"
import style0 from "./principleBranchForm.vue?vue&type=style&index=0&id=1575e1f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575e1f7",
  null
  
)

export default component.exports